import {useContext, useState} from "react";
import {FaFile, FaNewspaper, FaPaperclip, FaTimes} from "react-icons/fa";
import {LoadingContext, ToastContext, UserContext} from "../../contexts";
import {PublicacaoApi} from "../../apis";
import Logo from "../../assets/img/logo-h.png";

export const Arquivo = ({item, key, update}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const {setLoading} = useContext(LoadingContext);
  const [itemDetalhes, setItemDetalhes] = useState(null);
  const [itemArquivos, setItemArquivos] = useState(null);
  const {user} = useContext(UserContext);

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const openArquivo = async () => {
    setLoading(true);
    try {
      let respostaGetItem = await PublicacaoApi.getItem(user.uuid, item.uuid);
      if (!respostaGetItem.error) {
        await setItemDetalhes(respostaGetItem.data.publicacao);
        await setItemArquivos(respostaGetItem.data.arquivos);
        setModalOpen(true);
        try {
          let respostaView = await PublicacaoApi.setView(user.uuid, respostaGetItem.data.publicacao.uuid);
        } catch (e) {

        }
      } else {
        setLoading(false);
        AddToast({texto: respostaGetItem.error, tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
    setLoading(false);
  }

  const closeModal = () => {
    update();
    setModalOpen(false);
  }

  return (
    <div className="arquivo" key={key}>
      <div className="arquivo-item">
        <div className="publicacao-info">
          <span className="data">{item.data}</span>
          <span className={item.visto ? "titulo visto" : "titulo"}>{item.arquivo &&
            <FaPaperclip title="Há arquivo(s)"/>} {item.titulo}</span>
        </div>
        <div className="opcoes">
          <div className="btn btn-cancelar" onClick={openArquivo}>
            Visualizar
          </div>
        </div>
      </div>

      {modalOpen &&
        <div className="tela-modal-arquivo">
          <div className="modal-arquivo">
            <div className="modal-arquivo-cabecalho">
              <div className="titulo">
                <FaNewspaper size={30}/>
                <span>Publicação</span>
              </div>
              <div className="btn-close-modal" onClick={closeModal}>
                Fechar(
                <FaTimes/>
                )
              </div>
            </div>
            <div className="modal-arquivo-informacoes">
              <span className="data"></span>
              <h2 className="titulo">{itemDetalhes.titulo}</h2>
              <textarea disabled className="texto">{itemDetalhes.texto}</textarea>
              {itemArquivos.length > 0 &&
                <div className="modal-arquivo-arquivos">
                  {itemArquivos.map((item) => (
                    <a target="_blank" href={item.link} key={item.uuid} className="modal-arquivo-item" rel="noreferrer">
                      <FaFile size={24}/>
                      {item.nome}
                    </a>
                  ))}
                </div>
              }
              <hr/>
              <div className="modal-arquivo-info-complementar">
                {/*<span><b>Publicado por:</b> "Autor name" em "Criado data"</span>*/}
                {/*<span><b>Ultima alteração por:</b> Sem alterações</span>*/}
                <img src={Logo} alt="Logo"/>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}